import { reset } from 'redux-form';

import UserProfileApi from '../../../../api/user-profile-api';
import actionTypes from '../constants/action-types';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal, toggleDefaultErrorModal } from '../../../shared/info-modal/actions/info-modal-actions';
import { handleErrorResetPassword } from '../../reset-password/actions/reset-password-actions';
import ChangePasswordApi from '../../../../api/change-password-api';
import resetPasswordConstants from '../../reset-password/constants/reset-password-constants';
import CookiesWrapper from '../../../../common/cookies-wrapper';
import constants from '../../../../common/constants';

export const getUserProfile = () => {
  return async dispatch => {
    try {
      const response = await UserProfileApi.getUserProfile();
      const profile = response && response.data && response.data[0];
      const sessionTokens = Object.assign({}, CookiesWrapper.getCookie(constants.cookie_key_word)) || {};

      if (!sessionTokens.user_name) {
        sessionTokens.user_name = profile.user_name
      }

      if (sessionTokens.user_bo_status !== profile.bo_status) {
        sessionTokens.user_bo_status = profile.bo_status;
      }

      if (!sessionTokens.user_type) {
        sessionTokens.user_type = profile.user_type;
      }

      CookiesWrapper.setCookie(constants.cookie_key_word, sessionTokens);
      dispatch(handleSuccessGetUserProfile(profile));
    } catch (error) {
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const editUserProfile = data => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      /* eslint-disable */
      const response = await UserProfileApi.editUserProfile(data);
      /* eslint-enable */
      dispatch(handleHttpInProgress(false));
      dispatch(handleSuccessGetUserProfile(data));
      dispatch(toggleInfoModal(true, 'success', 'USER_PROFILE.SUCCESS_EDIT_MESSAGE'));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const changePassword = (email, oldPassword, newPassword) => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      /* eslint-disable */
      const response = await ChangePasswordApi.changePassword(email, oldPassword, newPassword);
      /* eslint-enable */
      dispatch(handleHttpInProgress(false));
      dispatch(reset(resetPasswordConstants.form_name));
      dispatch(toggleInfoModal(true, 'success', 'CHANGE_PASSWORD.SUCCESS_MESSAGE'));
    } catch (error) {
      const errorMessage = error && error.response && error.response.data;
      dispatch(handleHttpInProgress(false));
      if (errorMessage) {
        dispatch(handleErrorResetPassword(errorMessage));
      } else {
        dispatch(toggleDefaultErrorModal());
      }
    }
  };
};

export const handleSuccessGetUserProfile = profile => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_USER_PROFILE,
    data: profile,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/user-profile/actions/user-profile-actions.js